import { pickStrings } from '@/i18n';
import { adminStrings } from '@/i18n/dictionaries/admin';

/**
 * WEB-1091 §2/AC8 — the backend admin-panel RolesGuard throws machine-readable
 * UPPER_SNAKE error codes as the exception message (e.g. ADMIN_2FA_REQUIRED —
 * same convention as 2FA_ALREADY_ENABLED / INVALID_2FA_CODE elsewhere in
 * auth). Those must never reach a human verbatim.
 *
 * AdminRoute already blocks the FRESH-navigation case with a full "enable
 * 2FA" screen. But an admin panel that is ALREADY OPEN when the gate goes
 * live won't re-run that check until the next navigation — individual
 * widgets (usePulse and friends) will keep re-fetching admin/* data and get
 * this raw code back in the meantime. This is the single, central place
 * (wired into the axios response interceptor in client.ts, so every admin
 * API caller gets it for free) that maps such codes to a plain-language
 * sentence with a next step, instead of leaving each widget to show the raw
 * code — or worse, an inconsistent mix of them.
 */
/**
 * WEB-1900: фразы переехали в словарь панели (i18n/dictionaries/admin.ts) —
 * администратор с языком кабинета `en` видел здесь русский текст. КЛЮЧ карты
 * (`ADMIN_2FA_REQUIRED`) — машинный код протокола и не меняется.
 */
function adminErrorMessages(
  s: (typeof adminStrings)['en'],
): Record<string, string> {
  return {
    ADMIN_2FA_REQUIRED: s.admin2faRequired,
  };
}

export function friendlyAdminErrorMessage(
  message: string | undefined,
): string | undefined {
  if (!message) return message;
  return adminErrorMessages(pickStrings(adminStrings))[message] ?? message;
}
